import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import './localization/i18n';
import App from './App';
import Loader from './components/commons/Loader';

import './assets/css/tailwind.css';
import './assets/css/App.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';


ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback={<Loader size="full" containerClassName="bg-primary" />}>
      <Provider store={store}>
        <App />
        <ToastContainer />
      </Provider>
    </React.Suspense>
  </React.StrictMode>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// serviceWorker.register();